export default {"src":"/_next/static/media/ship-schools-dark.79ae89a3.svg","height":50,"width":112,"blurWidth":0,"blurHeight":0};